import { BasedOn } from '@wix/ambassador-bookings-v2-bookings-settings/types';
import { BusinessPropertyName, getBusinessInfo, getPropertyValue, isPropertyEnabled } from './businessInfo';
import { TimezoneType } from '@wix/bookings-uou-types';
export const legacyToBookingsSettings = legacy => {
  const info = getBusinessInfo(legacy);
  const clientCanChangeTimezone = isPropertyEnabled(legacy, BusinessPropertyName.CLIENT_CAN_CHANGE_TIMEZONE);
  const defaultTimezone = getPropertyValue(legacy, BusinessPropertyName.DEFAULT_TIMEZONE) || TimezoneType.BUSINESS;
  return {
    displayTimeZone: {
      basedOn: defaultTimezone === TimezoneType.BUSINESS ? BasedOn == null ? void 0 : BasedOn.BUSINESS_TIME_ZONE : BasedOn == null ? void 0 : BasedOn.CUSTOMER_TIME_ZONE,
      customerCanChange: clientCanChangeTimezone
    },
    siteProperties: {
      locale: {
        languageCode: (info == null ? void 0 : info.language) ?? '',
        country: (info == null ? void 0 : info.countryCode) ?? ''
      },
      language: (info == null ? void 0 : info.language) ?? '',
      timeZone: (info == null ? void 0 : info.timeZone) ?? '',
      email: (info == null ? void 0 : info.email) ?? '',
      phone: (info == null ? void 0 : info.phone) ?? '',
      paymentCurrency: (info == null ? void 0 : info.currency) ?? '',
      address: {
        googleFormattedAddress: (info == null ? void 0 : info.googleFormattedAddress) ?? ''
      },
      businessName: (info == null ? void 0 : info.name) ?? ''
    }
  };
};
//# sourceMappingURL=legacyToSettingsBusinessInfo.js.map